import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faMinus } from '@fortawesome/free-solid-svg-icons';
import { motion } from 'framer-motion';
import Footer from './Footer';
const Contact = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  const [showModal, setShowModal] = useState(false);
  const [emailErrorModal, setEmailErrorModal] = useState(false);
  const [detailsError, setDetailsError] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    const name = document.getElementById('name').value.trim();
    const email = document.getElementById('email').value.trim();
    const message = document.getElementById('message').value.trim();

    if (!name || !email || !message) {
      setDetailsError(true);
      return;
    }

    const formData = new FormData(e.target);
    const data = Object.fromEntries(formData.entries());

    const response = await fetch('/.netlify/functions/send-email', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });

    if (response.ok) {
      setShowModal(true);
    } else {
      setEmailErrorModal(true);
    }
    e.target.reset();
  };
  const sections = [
    {
      question: 'What Makes Lotez Suitable for Software Development?',
      content:
        "Lotez is suitable for software development because we combine technical expertise, a tailored approach, cutting-edge technologies, and a user-centered design philosophy to deliver custom software solutions that not only meet your needs today but are built to scale and evolve for tomorrow's challenges.",
    },
    {
      question: 'How Can Lotez Improve Your Product Growth?',
      content:
        'Lotez can improve your product growth by delivering customized solutions that align with your goals, optimizing user experiences, and driving continuous improvement through data-driven insights and innovative technologies. By focusing on scalability, agility, and effective marketing. Our collaborative approach ensures that technology aligns with your vision, giving you the tools and support to succeed in the long run.',
    },
    {
      question: 'Why Choose Lotez for Your Business Needs?',
      content:
        'Lotez provides cost-effective, scalable, and customizable options to fit businesses of all sizes and industries.',
    },
    {
      question: 'What Features Does Lotez Offer?',
      content:
        "Lotez offers a comprehensive suite of features that encompass all aspects of digital solution development. From custom software and mobile app development to AI integration, digital marketing, and cloud solutions, we provide end-to-end services that can help your business grow, adapt, and thrive in today's competitive landscape. Whether you're looking to improve user experience, increase online visibility, or innovate with cutting-edge technologies, Lotez has the expertise to deliver tailored solutions that meet your business needs.",
    },
  ];

  return (
    <>
      <div className="bg-homeColor min-w-[280px]">
        <div className="flex flex-col justify-center bg-homeColor items-center text-white">
          <motion.h1
            className="mt-32 font-bold text-5xl"
            initial={{ y: -100, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8 }}
          >
            Contact <span className="text-green">Us</span>
          </motion.h1>
          <motion.p
            className="w-[90%] text-center mt-5 sm:w-[50%] lg:w-[30%]"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5, duration: 1 }}
          >
            Drop us a message, and let's embark on a journey to elevate your
            brand's digital experience together.
          </motion.p>
          <div className="flex w-full bg-transparent justify-center">
            <motion.form
              className="bg-[#152523] bg-transparent border-2 mt-4 rounded-3xl lg:w-[40%] md:w-[80%] w-[90%] px-8 pt-6 pb-8 mb-4"
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.8, delay: 0.7 }}
              onSubmit={handleSubmit}
            >
              <motion.div
                className="mb-4"
                initial={{ opacity: 0, x: -50 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5 }}
              >
                <label
                  className="block text-white text-sm font-bold mb-2"
                  htmlFor="name"
                >
                  Name
                </label>
                <input
                  className="shadow appearance-none border-gray-300 rounded-3xl w-full py-2 px-3 bg-[#0D1817] leading-tight hover:border-green focus:outline-none focus:border-green"
                  id="name"
                  type="text"
                  name="name"
                  placeholder="Your Name"
                />
              </motion.div>
              <motion.div
                className="mb-6"
                initial={{ opacity: 0, x: 50 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5, delay: 0.3 }}
              >
                <label
                  className="block text-white text-sm font-bold mb-2"
                  htmlFor="email"
                >
                  Email
                </label>
                <input
                  className="shadow appearance-none border-gray-300 bg-[#0D1817] rounded-3xl w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline focus:border-green hover:border-green"
                  id="email"
                  type="email"
                  name="email"
                  placeholder="Your Email"
                />
              </motion.div>
              <motion.div
                className="mb-6"
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.5 }}
              >
                <label
                  className="block text-white text-sm font-bold mb-2"
                  htmlFor="message"
                >
                  Message
                </label>
                <textarea
                  className="w-full h-32 p-4 border-gray-300 rounded-md bg-[#0D1817] focus:outline-none focus:ring-2 focus:ring-green"
                  placeholder="Enter your text here..."
                  id="message"
                  name="message"
                ></textarea>
              </motion.div>
              <motion.div
                className="flex items-center justify-between"
                initial={{ scale: 0.8 }}
                animate={{ scale: 1 }}
                transition={{ duration: 0.5, delay: 0.6 }}
              >
                <button
                  className="bg-green hover:bg-green-700 text-homeColor w-full font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                  type="submit"
                >
                  Submit
                </button>
              </motion.div>
            </motion.form>
          </div>
        </div>
        {showModal && (
          <div className="w-full fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
            <div className="w-[90%] lg:w-[30%] bg-white p-6 rounded-lg shadow-lg text-center">
              <h2 className="text-xl font-bold text-gray-900">Message Sent!</h2>
              <p className="mt-2 text-gray-600">
                Thank you for reaching out. We will get back to you soon.
              </p>
              <button
                className="mt-4 px-6 py-2 bg-green text-white rounded hover:bg-green-700"
                onClick={() => setShowModal(false)}
              >
                OK
              </button>
            </div>
          </div>
        )}
        {emailErrorModal && (
          <div className="w-full fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
            <div className="w-[90%] lg:w-[30%] bg-white p-6 rounded-lg shadow-lg text-center">
              <h2 className="text-xl font-bold text-gray-900">
                Message Failed!
              </h2>
              <p className="mt-2 text-gray-600">Sorry,please try again</p>
              <button
                className="mt-4 px-6 py-2 bg-green text-white rounded hover:bg-green-700"
                onClick={() => setEmailErrorModal(false)}
              >
                OK
              </button>
            </div>
          </div>
        )}
        {detailsError && (
          <div className="w-full fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
            <div className="w-[90%] lg:w-[30%] bg-white p-6 rounded-lg shadow-lg text-center">
              <h2 className="text-xl font-bold text-gray-900">
                Details Required!
              </h2>
              <p className="mt-2 text-gray-600">
                Please fill in all fields before submitting.
              </p>
              <button
                className="mt-4 px-6 py-2 bg-green text-white rounded hover:bg-green-700"
                onClick={() => setDetailsError(false)}
              >
                OK
              </button>
            </div>
          </div>
        )}
        <div className="bg-cardColor flex flex-col lg:flex-row mt-20 justify-center items-center gap-x-20 gap-y-10 text-white">
          <div className="flex flex-col w-[80%] justify-center lg:w-[40%]">
            <h1 className="font-bold text-3xl">
              Frequently Asked
              <br /> Questions
            </h1>
            <p className="text-xl mt-6">
              Explore our Frequently Asked Questions (FAQ) to find quick answers
              and insights about our services, templates, and processes.
            </p>
          </div>

          <div className="flex flex-col border-2 w-[80%] lg:w-[40%] rounded-2xl bg-[#0D1817] p-5 space-y-6">
            {sections.map((section, index) => (
              <div key={index} className="flex flex-col text-xl">
                <div
                  className="flex justify-between items-center border-b-2 pb-2 mb-4 cursor-pointer text-white"
                  onClick={() => toggleAccordion(index)}
                >
                  <span>{section.question}</span>
                  <FontAwesomeIcon
                    icon={activeIndex === index ? faMinus : faPlus}
                  />
                </div>

                {activeIndex === index && (
                  <div className="text-base text-gray-400 mt-2">
                    <p>{section.content}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default Contact;
